import React from "react"
import { Stack } from "@chakra-ui/react"

import {
  LearnPage,
  LearnPageAttributes,
  LearnPageBadges,
  LearnPageDescription,
  LearnPageImageRatio,
  LearnPageTitle,
} from "@components/LearnPage"
import { ArticleGridItemProps } from "."

const ArticleGridItemDesktop = ({ item, handleTrackingClick }: ArticleGridItemProps) => (
  <LearnPage item={item} handleTrackingClick={handleTrackingClick}>
    <LearnPageImageRatio aspectRatioProps={{ mb: 2 }} />
    <Stack spacing={1}>
      <LearnPageBadges />
      <LearnPageTitle />
      <LearnPageDescription />
      <LearnPageAttributes />
    </Stack>
  </LearnPage>
)

export default React.memo(ArticleGridItemDesktop)
